import { Container, Grid } from "@mui/material";
import React, { useState } from "react";
import Logo from "../../../../styles/img/df-logo.png";
import AccountNoImage from "../../../../styles/img/onboard/account-no.png";
import { CloseIcon } from "../../../../styles/img/svg/CloseIcon";
import { useNavigate } from "react-router-dom";
import { BackIcon } from "../../../../styles/img/svg/BackIcon";
import { UiButton } from "../../component/common/UiButton";
import UiInput from "../../component/common/UiInput";
import { UiProgressbar } from "../../component/_uiComponents/UiProgressbar";

export const UiAccountNoStepTwo = () => {
  const [accNumber, setAccNumber] = useState("123456789");

  const navigate = useNavigate();

  const backToHome = () => {
    navigate("/ui/login");
  };

  return (
    <>
      <div className="df-logo-nav">
        <Container maxWidth="xl">
          <div className="df-logo-nav__content">
            <img src={Logo} />
          </div>
        </Container>
      </div>
      <div className="df-user-profile df-preset-card df-onboard-progress-back-close df-profile-top-aligned-box">
        <Container maxWidth="md" className="df-pos-rel">
          <div
            className="df-user-profile__close-icon df-onboard-close-icon"
            onClick={backToHome}
          >
            <CloseIcon />
          </div>

          <div className="df-user-profile__back-icon df-bc-w-progress">
            <UiProgressbar />

            <BackIcon onClick={backToHome} />
          </div>

          <div className="df-user-profile__body df-pw-tab">
            <Grid container>
              <Grid size={{ xs: 12, sm: 6, lg: 6, xl: 6 }}>
                <h2 className="df-reset-pw-title text-center">
                  Enter your account number
                </h2>

                <img
                  src={AccountNoImage}
                  className="df-reset-pw-img df-onboard-side-img"
                />
              </Grid>

              <Grid
                size={{ xs: 12, sm: 6, lg: 6, xl: 6 }}
                className="text-right df-pl-2"
              >
                <div className="df-onboard-nic-wr">
                  <UiInput
                    label="Account Number *"
                    type="text"
                    varient="outlined"
                    value={accNumber}
                    inputonChange={(e) => setAccNumber(e.target.value)}
                  />

                  <UiButton
                    className="df-ui-dark-bg-btn w-100 df-onboard-radio-btn"
                    name="Next"
                  />
                </div>
              </Grid>
            </Grid>
          </div>
        </Container>
      </div>
    </>
  );
};
